'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTIVE_SCREEN_KEY = exports.ACTIVE_SCREEN_KEY = 'activeScreen';

// used for module-level bus subscriptions that should never get disposed
var MODULE_SCREEN_KEY = exports.MODULE_SCREEN_KEY = 'MODULE_SCREEN_KEY';

var getScreenKey = exports.getScreenKey = function getScreenKey(screenKey) {
  return screenKey ? screenKey : ACTIVE_SCREEN_KEY;
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screen/ScreenKeyConst.js
// module id = 18
// module chunks = 10